import { createRouter, createWebHistory } from 'vue-router';

import About from './pages/allGazi/About.vue';
import Contact from './pages/allGazi/Contact.vue';
import NotFound from './pages/NotFound.vue';
import Projects from './pages/allGazi/Projects.vue';
import Team from './pages/allGazi/Team.vue';

const Home = () => import('./pages/allGazi/Home.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/home' },
    {
      path: '/team',
      component: Team,
      meta: {
        title: 'Gartenbau GAZI, Pflege,Leistungen,Team',
        description: 'Unsere Team, Gartengestaltung, Pflege und Zäune',
      },
    },
    { path: '/contact', component: Contact },
    { path: '/projects', component: Projects },
    { path: '/about', component: About },
    { path: '/home', component: Home },
    { path: '/:notFound(.*)', component: NotFound },
  ],
  scrollBehavior(to, from, savedPosition) {
    // if the user used the browser's back/forward button
    if (savedPosition) {
      return savedPosition;
    } else {
      // always scroll to top
      return { top: 0 };
    }
  },
});

router.beforeEach(function (to, _, next) {
  // let isAuth = false;
  // if (to.meta.requiresAuth && !isAuth) {
  //   next('/home');
  // } else if (to.meta.requiresUnauth && isAuth) {
  //   next('/home');
  // } else {
  //   next();
  // }

  if (to.meta.title) document.title = to.meta.title;
  if (to.meta.description) {
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', to.meta.description);
  }
  next();
});

export default router;
